export default {
  getUserAgent() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return "WeChatPay";
    } else if (ua.match(/AlipayClient/i) == "alipayclient") {
      return "AliPay";
    } else {
      return "H5";
    }
  },
  cardName() {
    const mallNameList = ["gongyinas"];
    const mallName = window.location.host.split(".")[0];
    if (mallNameList.indexOf(mallName) > -1) {
      return {
        name: "购物车",
        type: true
      };
    }
    return {
      name: "兑换袋",
      type: false
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/common.js